export default "__VITE_PUBLIC_ASSET__1004d189__"